import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id A54ADA14-0917-432E-9288-3364FBAEBCE2
 * name toggle-switch-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toggle-switch-off.svg
 * tags
 */
export const ToggleSwitchOffIcon = createSvgIcon(<><path d="M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M7,15A3,3 0 0,1 4,12A3,3 0 0,1 7,9A3,3 0 0,1 10,12A3,3 0 0,1 7,15Z" /></>, 'ToggleSwitchOffIcon');
export default ToggleSwitchOffIcon